/*
===============================================================================
bieonboardingworkbook.apis.ts

Direct client API functions for:
    service: bieonboarding

The middleware upload extension converts the framework file-upload request
into the PostgreSQL workbook-upload contract.
===============================================================================
*/

import { generateTrackId, json, postBiz, uploadBiz } from '../core/coreapi';

import {
  BieOnboardingWorkbookOperationResult,
  BieOnboardingWorkbookReview,
  BieOnboardingWorkbookUploadRequest,
} from './bieonboardingworkbook.models';

import {
  normalizeBieOnboardingWorkbookOperation,
  normalizeBieOnboardingWorkbookReview,
} from './bieonboardingworkbook.normalizers';

const SERVICE = 'bieonboardingworkbook';

/*
 * This should match the registered BieOnboardingWorkbookParser prefix.
 */
const UPLOAD_PREFIX = 'bieonb';

export async function reviewBieOnboardingWorkbook(
  loadSessionId: number
): Promise<BieOnboardingWorkbookReview> {
  const response = await postBiz({
    s: SERVICE,
    a: 'review',
    lsi: loadSessionId,
  });

  return normalizeBieOnboardingWorkbookReview(json(response));
}

export async function uploadBieOnboardingWorkbook(
  request: BieOnboardingWorkbookUploadRequest
): Promise<BieOnboardingWorkbookOperationResult> {
  const response = await uploadBiz({
    service: SERVICE,
    action: 'upload',

    prefix: UPLOAD_PREFIX,

    file: request.file,

    params: {
      tki: request.trackId ?? generateTrackId(),
      lsi: request.loadSessionId,
      rex: request.replaceExisting ? 1 : 0,
      rmk: request.remarks || '',
    }

    
  } as any);

  return normalizeBieOnboardingWorkbookOperation(json(response));
}

export async function validateBieOnboardingWorkbook(
  loadSessionId: number,
  stamp: string
): Promise<BieOnboardingWorkbookOperationResult> {
  const response = await postBiz({
    s: SERVICE,
    a: 'validate',
    lsi: loadSessionId,
    stp: stamp,
  });

  return normalizeBieOnboardingWorkbookOperation(json(response));
}
